<template>
  <div
    class="sidebar-wrapper"
  >
    <b-nav vertical class="active">
      <slot name="sidebar-header">
        <div slot="sidebar-header" class="sidebar-header">
          <div
            class="circle"
            v-if="currentClient.logo_image"
            @click="openLogoModal"
          >
            <img :src="currentClient.logo_image" :alt="currentClient.name" />
          </div>
          <div v-else>
            <div class="circle" @click="openLogoModal"><br />Company Logo<span class="icon-upload-image"></span></div>
          </div>
          <div class="mt-2 user-name-sidebar">{{ userInfo.firstName }} {{ userInfo.lastName }}</div>
          <div class="mt-2 client-name-sidebar">{{ currentClient.name }}</div>
          <b-button  pill variant="outline-primary" class="mt-3 logout-btn-sidebar" @click="logout">Log Out</b-button>
        </div>
      </slot>
      <template v-for="(item, index) in navItems">
        <div class="item-wrapper" v-if="hasPermission(item) && !item.hidden" :key="index">
          <div v-if="item.line" class="bottomLine"></div>
          <div v-if="item.overview" class="overview">{{ item.overview }}</div>
          <template>
            <SidebarNavIcons
              :icon="item.icon"
              v-if="item.children"
              v-b-toggle="item.collapse_id"
              :name="item.name"
              :url="item.url"
              :expandIcon="item.expandIcon"
            ></SidebarNavIcons>
            <SidebarNavIcons
              :icon="item.icon"
              v-else
              :name="item.name"
              :url="item.url"
            ></SidebarNavIcons>
          </template>
          <b-collapse
            v-if="item.children && item.expandIcon"
            :id="item.collapse_id"
            accordion="my-accordion"
          >
            <ul class="children-nav">
              <template v-for="(children, subIndex) in item.children">
                <li v-if="!children.hidden && hasPermission(children)" :key="subIndex">
                  <template>
                    <SidebarNavIcons
                      :icon="item.icon"
                      :name="children.name"
                      :url="children.url"
                    ></SidebarNavIcons>
                  </template>
                </li>
              </template>
            </ul>
          </b-collapse>
        </div>
      </template>
    </b-nav>
  </div>
</template>

<script>
import SidebarNavIcons from "./SidebarNavIcons";
import consts from "@/_consts";
import { mapActions, mapGetters } from "vuex";
import { ACTION_EDIT_EMPLOYER } from "@/store/modules/employers/constants";
import { GETTER_USER_INFO, ACTION_DO_LOGOUT } from "@/store/modules/users/constants";
export default {
  name: "sidebar",
  props: {
    navItems: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      currentClient: "",
      modalData: {
        action: consts.modalAction.openLogoModal,
        data: null,
        okClickHandle: this.saveLogo
      },
      userPermissionsData: null
    };
  },
  mounted() {
    this.loadUserPermissionsData();
  },
  watch: {
    '$route'() {
      this.loadUserPermissionsData();
    }
  },
  computed: {
    userInfo() {
      return this.getUserInfo;
    },
    ...mapGetters({
      getUserInfo: GETTER_USER_INFO
    })
  },
  components: {
    SidebarNavIcons
    // ReportingExtracts
  },
  methods: {
    ...mapActions({
      editEmployer: ACTION_EDIT_EMPLOYER,
      doLogout: ACTION_DO_LOGOUT,
    }),
    loadUserPermissionsData() {
      const permission = sessionStorage.getItem(consts.LOCAL_STORE.permission);
      this.userPermissionsData = permission ? JSON.parse(permission) : null;
    },
    hasPermission(item) {
      if (item.permissionName && item.permissionName.length) {
        return this.userPermissionsData && this.userPermissionsData.some(i => i.name === item.permissionName);
      }
      // If there is no permissionName declared on the nav item, always show that item
      return true;
    },
    logout() {
      this.doLogout().then(() => {
        this.$router.push("/login");
        // re-set user info after logout
        this.$ga.set("userId", "N/A");
        this.$ga.set("role", "");
        this.$ga.set("employer_ids", "");
      });
    },
    openLogoModal() {
      this.modalData.action = consts.modalAction.openLogoModal;
      this.modalData.data = this.currentClient;
      this.$modal.show("eventModal", this.modalData);
    },
    saveLogo() {
      const payload = {
        data: {
          logo_image: this.currentClient.logo_image
        },
        id: this.currentClient.id,
        callback: this.$Progress.finish(),
        errorHandling: this.$Progress.finish(),
        successMessage: "Update logo successfully."
      };
      this.$Progress.start();
      this.editEmployer(payload);
    },
    updateCurrentClient() {
      if (localStorage.getItem(consts.LOCAL_STORE.client)) {
        try {
          const client = JSON.parse(
            localStorage.getItem(consts.LOCAL_STORE.client) || {}
          );
          this.currentClient = client;
        } catch (e) {
          console.log("GET local client err: ", e);
        }
      }
    }
  },
  created() {
    this.updateCurrentClient();
  }
};
</script>

<style lang="scss">
@import "~@/assets/styles/_core-variables";

.sidebar-wrapper {
  font-size: 0.75rem;
  .sidebar-header {
    text-align: center;
    padding-top: 40px;
    padding-bottom: 45px;
    color: $white;
    .user-name-sidebar{
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      padding: 0 10px;
    }
    .client-name-sidebar{
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      color: $grey-4;
      padding: 0 10px;
    }
    .logout-btn-sidebar{
      border-color: $white;
      color: $white;
      border-radius: 30px;
      padding: 5px 10px;
      text-transform: capitalize;
    }
  }
  .sidebar-nav {
    background: $aduro-primary-color;
    height: 100%;
  }
  .circle {
    height: 48px;
    min-width: 48px;
    width: 48px;
    align-items: center;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    line-height: normal;
    position: relative;
    text-align: center;
    vertical-align: middle;
    box-sizing: border-box;
    border: 1px solid $light-grey;
    background-color: $white;
    font-size: 9px;
    color: $aduro-primary-color;
    cursor: pointer;
    .icon-upload-image{
      position: absolute;
      right: 5px;
      bottom: 0px;
    }
  }
  .circle img {
    border-radius: inherit;
    display: inline-flex;
    height: inherit;
    width: inherit;
  }
  .nav {
    &.active {
      .circle {
        height: 124px;
        width: 124px;
        font-size: 12px;
      }
    }
  }
}
.client-sidebar {
  .nav-link {
    cursor: pointer;
  }
  ul.nav li.nav-item {
    ul {
      background-color: white;
      list-style: none;
      margin: 0;
      padding: 0;
      visibility: hidden;
      position: absolute;
      top: 1px;
      left: 100%;
      z-index: 598;
      width: 194px;
      border-top: 1px solid $grey-5;
      border-left: 1px solid $grey-5;
      border-right: 1px solid $grey-5;
      li {
        border-bottom: 1px solid $grey-5;
      }
      li a {
        color: $aduro-primary-color;
        display: block;
        padding: 5px 10px;
        text-decoration: inherit;
        &:hover {
          background-color: $aduro-primary-color;
          color: $white;
        }
      }
    }
    &:hover {
      ul {
        visibility: visible;
      }
    }
  }

  .sidebar-nav {
    overflow-x: hidden;
    overflow-y: auto;

    &::-webkit-scrollbar-track {
      background-color: lighten($grey-5, 5%);
      border-right: 1px solid darken($grey-5, 5%);
      border-left: 1px solid darken($grey-5, 5%);
    }

    &::-webkit-scrollbar-thumb {
      height: 50px;
      background-color: darken($grey-5, 10%);
      background-clip: content-box;
      border-color: transparent;
      border-style: solid;
      border-width: 1px 2px;
    }

    @media (max-width: 991.98px) {
      min-height: calc(100vh - 100px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue